import { useQuery } from '@tanstack/react-query';
import uuid from 'react-uuid';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { Department } from 'src/types/department';
import axiosInstance from 'src/utils/axios';

interface DepartmentResponse {
  buId: string;
  departments: Department[];
}

async function fetchDepartments(companyId: string): Promise<DepartmentResponse> {
  const res = await axiosInstance.get<DepartmentResponse>(api.department(companyId));
  const transformedData: Department[] = res.data?.departments.map((item) => ({
    ...item,
    selected: false,
    rowId: uuid(),
    editedName: item.name,
    members: item.members.map((member) => ({
      ...member,
      selected: false,
      isDirty: false,
      rowId: uuid(),
    })),

    glCodes: item.glCodes.map((glCode) => ({
      ...glCode,
      name: `${glCode.code} ${glCode.description}`,
      selected: false,
      isDirty: false,
      rowId: uuid(),
    })),
  }));
  return { departments: transformedData, buId: res.data.buId };
}

export function useGetDepartmentQuery(companyId: string) {
  return useQuery<DepartmentResponse>({
    queryKey: [...queryKeys.department.departmentList(companyId)],
    queryFn: () => fetchDepartments(companyId),
    enabled: Boolean(companyId),
  });
}
